import { axiosGet, axiosPatch, axiosPost } from "./axiosService";

const baseTransferURL = "/transfers";

export class TransferService {
  addTransferIn(amount, loanId = undefined) {
    return axiosPost({ amount, loanId }, baseTransferURL + "/deposit");
  }

  addTransferOut(amount) {
    return axiosPost({ amount }, baseTransferURL + "/withdrawal");
  }

  cancelTransfer(transferId) {
    return axiosPatch(baseTransferURL + "/cancel", {
      correlationId: transferId,
    });
  }

  getDepositHistory() {
    return axiosGet(null, baseTransferURL + "/deposit");
  }

  getWithdrawHistory() {
    return axiosGet(null, baseTransferURL + "/Withdrawal");
  }

  getTransferHistory() {
    return axiosGet(null, baseTransferURL + `/History`);
  }
}
